import store from "@/store";

export default class Roles {
    static async all(axios) {
        const response = await axios?.post(
            "/graphql/",
            `query{
              rolesList{
                results{
                  id
                  name
                  rolesPermission{
                    id
                    name
                  }
                  userRole{
                    id
                    username
                    email
                  }
                }
              }
            }`,
            {
                headers: {
                    "Content-Type": "application/graphql",
                },
            }
        );
        console.log("roles: ", response.data.data?.rolesList.results);
        return response.data.data?.rolesList.results;
    }

    static async retrieve(axios, id) {
        const response = await axios
            .post(
                "/graphql/",
                `query{
                  rolesRetrieve(id:${id}){
                    id
                    name
                    rolesPermission{
                      id
                      name
                    }
                  }
                }`,
                {
                    headers: {
                        "Content-Type": "application/graphql",
                    },
                }
            )
            .catch(function (error) {
                if (error.response) {
                    console.log("primer strike");
                    return null;
                } else if (error.request) {
                    console.log("segudo strike");

                    return null;
                } else {
                    console.log("3er strike");
                    return null;
                }
            });

        if (response) {
            if (
                response.data.data.rolesRetrieve
            ) {
                response.data.data.rolesRetrieve.compressed = {
                    permission: response.data.data.rolesRetrieve.rolesPermission.map((rolesPermission) => rolesPermission),
                };
            }
            return response.data.data.rolesRetrieve;
        }
    }
    static async edit(
        axios,
        id,
        name,

    ) {

        const response = await axios?.post(
            "/graphql/",
            `mutation{
                  updateRole(newRoles:{
                    id: ${id}
                    name: "${name}"
                  }){
                    roles{
                      id
                      name
                      rolesPermission{
                        id
                        name
                      }
                    }
                    ok
                    errors{
                      field
                      messages
                    }
                  }
                }`,
            {
                headers: {
                    "Content-Type": "application/graphql",
                },
            }
        ).catch(function (error) {
            if (error.response) {
                store.dispatch('actionsSetErrorMessage', error.response);
                console.log("primer strike");
                return null;
            } else if (error.request) {
                console.log("segudo strike");
                store.dispatch('actionsSetErrorMessage', error.request);

                return null;
            } else {
                console.log("3er strike");
                store.dispatch('actionsSetErrorMessage', '3er strike');

                return null;
            }
        });
        if (response !== null && response.data !== undefined && !response.data.errors) {
            if (response.data.data.updateRole.ok) {
                return response.data.data.updateRole.ok;
            }
            else if (response.data.data.updateRole.errors) {
                let errores = response.data.data.updateRole.errors;
                let mensajes = [];

                for (let i = 0; i < errores.length; i++) {
                    let error = errores[i];
                    for (let j = 0; j < error.messages.length; j++) {
                        mensajes.push(error.messages[j]);
                    }
                }
                console.log("lo que tenemos: ", response.data.data.updateRole.errors);
                await store.dispatch('actionsSetErrorMessage', mensajes);
                return null;
            }
        } else if (response.data.errors){
            console.log("lo que tenemos errors: ", response.data.errors[0].message);

            await store.dispatch('actionsSetErrorMessage', response.data.errors[0].message);
            return null;
        }
        else {
            return null;
        }
    }

    static async create(
        axios,
        name,

    ) {

        const response = await axios?.post(
            "/graphql/",
            `mutation{
              createRoles(newRoles:{
                name: "${name}"
              }){
                ok
                errors{
                  field
                  messages
                }
                roles{
                  id
                  name
                  rolesPermission{
                    id
                    name
                  }
                  userRole{
                    id
                    username
                    email
                  }
                }
              }
            }`,
            {
                headers: {
                    "Content-Type": "application/graphql",
                },
            }
        ).catch(function (error) {
            if (error.response) {
                store.dispatch('actionsSetErrorMessage', error.response);
                console.log("primer strike");
                return null;
            } else if (error.request) {
                console.log("segudo strike");
                store.dispatch('actionsSetErrorMessage', error.request);

                return null;
            } else {
                console.log("3er strike");
                store.dispatch('actionsSetErrorMessage', '3er strike');

                return null;
            }
        });
        if (response !== null && response.data !== undefined && !response.data.errors) {
            if (response.data.data.createRoles.ok) {
                return response.data.data.createRoles.ok;
            }
            else if (response.data.data.createRoles.errors) {
                let errores = response.data.data.createRoles.errors;
                let mensajes = [];

                for (let i = 0; i < errores.length; i++) {
                    let error = errores[i];
                    for (let j = 0; j < error.messages.length; j++) {
                        mensajes.push(error.messages[j]);
                    }
                }
                console.log("lo que tenemos: ", response.data.data.createRoles.errors);
                await store.dispatch('actionsSetErrorMessage', mensajes);
                return null;
            }
        } else if (response.data.errors){
            console.log("lo que tenemos errors: ", response.data.errors[0].message);

            await store.dispatch('actionsSetErrorMessage', response.data.errors[0].message);
            return null;
        }
        else {
            return null;
        }
    }

    static async delete(axios, id) {
        const response = await axios.post(
            "/graphql/",
            {
                query: `mutation deleteRoles ($id: ID!){
                      deleteRoles(id: $id){
                        ok
                      }
                    }`,
                variables: {
                    id: id,
                },
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data.data.deleteRoles.ok;
    }
}
